import type { Request } from 'express';

export function getCookiesFromRequest(req: Request): Record<string, string> {
  const cookies = (req.cookies || {}) as Record<string, string>;
  return cookies;
}
